import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {StorageService,SessionService} from './storage.service';
import { PrinterService } from './printer.service';
//import { LocalStorageService,SessionStorageService } from 'angular-web-storage';

@NgModule({
  imports: [
    CommonModule
  ],
  providers:[
  //  LocalStorageService,SessionStorageService,
    StorageService,SessionService,PrinterService
  ],
  declarations: [],
  exports:[
    
  ]
})
export class ServicesModule { }
